module.exports = {
  apiHost: "https://api.rosellarise.sensoreal.app",
  assetsHost: "https://assets.rosellarise.sensoreal.app",
  brandName: "Rosella Rise",
  header: {
    text: { en: "Your Rosella Rise Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#0c1636",
    textColor: "#fff",
    font: "avenir",
  },
  contact: {
    website:
      "https://www.avjennings.com.au/communities/nsw/rosella-rise-warnervale-2259",
    address: "35 Warnervale Road, Warnervale NSW",
    phone: "131 878",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "https://www.facebook.com/avjenningsbyavid/",
  },
  footerLogo: "",
};
